import { LayoutPanelTop } from "lucide-react";

import BUTTON_TYPES from "@/lib/constants/buttonTypes";
import { SECTION_TYPES } from "@/lib/constants/sections";

const homeHeroSection = {
  type: SECTION_TYPES.HOME_HERO,
  content: {
    variantNumber: 1,
    header: "Content will go here...",
    subheader: "This is a lovely place for a subtitle, coming soon...",
    bgImage: {
      alt: "",
      providerId: "",
      source: "",
      url: "https://images.unsplash.com/photo-1592595896551-12b371d546d5?q=60&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3",
    },
    showCustomButtons: false,
    buttons: [
      {
        type: BUTTON_TYPES.SITE_LINK,
        label: "Get in touch",
        link: "/contact-us",
      },
      {
        type: BUTTON_TYPES.EXTERNAL_LINK,
        label: "Find us here too",
        link: "https://google.com",
      },
    ],
  },
  meta: {
    displayName: "Intro Section",
    displayDescription: "Introduce your business to your customers.",
    displayIcon: LayoutPanelTop,
    variantsCount: 10,
  },
};

export default homeHeroSection;
